
import {
    Component,
    Emit,
    Prop,
    Provide,
    ProvideReactive,
    Watch,
} from "vue-property-decorator";
import {
    IQuickUnit,
    IQuickUnitAny,
    IQuickUnitSubTree,
    QuickHelper,
} from "@root/core/utilities/quick-helper";
import {
    FindRouter,
    IQuery,
    IQueryDefault,
    ObjectHelper,
    StringHelper,
} from "@root/core";
import { BaseQuick } from "../lib/core";
import QuickList from "../quick-list/quick-list.vue";
import { PermissionHelper } from "@root/core/utilities/permission-helper";

@Component
export default class QuickDetail extends BaseQuick {
    /// portal ///////////////////
    @ProvideReactive()
    autoQuickInstance: Vue | undefined;

    get autoComponentId() {
        return `auto-quick-component-${this._uid}`;
    }
    private created() {
        this.autoQuickInstance = this as any;
    }
    //////////////////////////////

    /// base
    @Prop({ type: String, required: false })
    id?: string;

    @Emit("updated")
    doUpdate(value) {
        return value;
    }

    /// private helpers
    get routeIcon(): string | null {
        const path = this.$route.path.split("/").slice(0, -1).join("/");

        let routers = FindRouter({ path });
        if (routers.length === 0) return null;
        return routers[routers.length - 1].icon as string;
    }

    get children(): Required<IQuickUnitSubTree>[] {
        return (
            (this.quick.children?.() ?? [])
                .map((o) => QuickHelper.generalize(o))
                .filter((o) => o.hidden != true)
                // filter allow
                .filter(
                    (o) =>
                        o.quick.allowRead == null ||
                        PermissionHelper.check.call(this, o.quick.allowRead),
                )
                // filter deny
                .filter(
                    (o) =>
                        o.quick.denyRead == null ||
                        !PermissionHelper.check.call(this, o.quick.denyRead),
                )
        );
    }

    /// root modal id
    get modalId() {
        return this.id ?? this.$route.params.id;
    }
    /// root modal name, ex: PropertyGroup
    get modalName() {
        return StringHelper.pascalize(this.quick.path);
    }
    get modalPropertyName() {
        return StringHelper.camelize(this.quick.path);
    }

    /// connect to the relation of modalId
    connectParam(id) {
        return {
            [this.modalPropertyName]: {
                id,
            },
        };
    }

    /// make connection
    query: IQuery = IQueryDefault();

    serverU(id) {
        return QuickHelper.serverU(this.quick, id);
    }

    get serverDetail() {
        // return {
        //     path: this.quick.path,
        //     method: "U",
        //     /// paramsDetail may return mutable value should not be cloned.
        //     params: ObjectHelper.deepMerge(
        //         this.quick.paramsDetail?.call(this.quick),
        //         QuickHelper.includeParents(this.quick),
        //         QuickHelper.includeFiles(this.quick),
        //         this.autoWhereId(this.modalId),
        //     ),
        // };
        return ObjectHelper.deepMerge(QuickHelper.serverDetail(this.quick), {
            params: this.autoWhereId(this.modalId),
        });
    }
    /// current page data cache
    row: any = null;
    count: any = {};
    doReload(value) {
        this.row = value;

        /// count the children
        for (let idx = 0; idx < this.children.length; ++idx) {
            const child = this.children[idx];
            const quick = child.quick;
            const params = ObjectHelper.deepMerge(
                quick.paramsWhere?.call(quick),
                {
                    where: this.connectParam(this.modalId),
                },
                {
                    select: { id: true },
                    paging: { page: 1, pageSize: 1 },
                },
            );
            /// delete the include since `select` already exists.
            delete params.include;
            this.$server
                .R(
                    quick.path as any,
                    /// paramsWhere may return mutable value should not be cloned.
                    params,
                )
                .then((o: any) => {
                    this.$set(this.count, idx, o.paging.total);
                    //this.count[idx] = o.paging.total;
                });
        }
    }
    reload() {
        (this.ref("form").ref as any)?.reload?.();
    }

    // server params CRUD
    get paramsList() {
        return {
            where: {
                [this.modalPropertyName]: {
                    id: this.modalId,
                },
            },
        };
    }

    /// tab handler
    selected = 0;

    /// title images
    get images() {
        if (this.row == null || this.row.files == null || this.row.files.length === 0)
            return null;

        const result = this.row.files
            /// only show image file
            .filter((file) => /^image\//.test(file.contentType))
            .map((file) => {
                return {
                    title: file.title,
                    image: this.$server.UrlFile(file),
                };
            });
        if (result.length === 0) return null;
        return result;
    }

    /// detail handler
    showDetail: boolean = false;
    get uiHiddenMeta(): any {
        /// basic: true | false | 'inherit'
        /// detail: true | false | 'inherit'
        return this.showDetail
            ? (o) =>
                  o.meta?.detail == undefined
                      ? "inherit"
                      : o.meta?.detail === true
                        ? false
                        : o.meta?.detail === false
                          ? true
                          : o.meta?.detail
            : (o) =>
                  o.meta?.basic == undefined
                      ? true
                      : o.meta?.basic === true
                        ? false
                        : o.meta?.basic === false
                          ? true
                          : o.meta?.basic;
    }

    /// ref CRUD
    ref(type: string, key?: any) {
        const id = `ref-${type}-${key}`;
        let ref = this.$refs[id];
        if (Array.isArray(ref)) ref = ref[0];
        const result = { id, ref };
        return result;
    }
}
